module.exports = " <div class=homeview _v-3acd00c6=\"\"> <div class=home-img _v-3acd00c6=\"\"> <img src=" + require("../assets/img/campus-home.png") + " _v-3acd00c6=\"\"> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.5.4@vue-loader/lib/template-rewriter.js?id=_v-3acd00c6!./~/.8.5.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/home.vue
// module id = 29
// module chunks = 2